<template>
    <div class="yh-page">
      <el-card v-loading="loading" :element-loading-text="loadingText">
        <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
          <el-col :span="14">
            <span>
              <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-plus" @click="handleReceivableCreate">添加开票</el-button>
            </span>
            &nbsp;
            <!-- <span>
              <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-s-release" @click="handleNoInvoice(showDialogSave)">设置不开票金额</el-button>
            </span>
            &nbsp; -->
            <template v-if="is_completed && showConfirm">
            <span>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleConfirm">完成开票确认</el-button>
            </span>
            &nbsp;
            </template>
            <span>
              <el-button type="primary" size="small" icon="el-icon-back" @click="() => {this.$router.go(-1)}">返回</el-button>
            </span>
            &nbsp;
            <span>
              <el-button type="primary" size="small"  @click="CreateInvoiceTitleDetail">新增开票信息</el-button>
            </span>
          </el-col>
        </el-row>
  
        <el-collapse v-model="activeNames">
          <el-collapse-item title="账务概况" name="1">
            <el-row>
              <span style="color: blue;">
                注释：<br/>
                开票 —— 包括专票、普票、收据; <br/>
                抵扣部分不开票金额 —— 优先在保费开票额度中扣除
              </span>
            </el-row>
            <table>
              <tr>
                <th width="100px">业务数</th>
                <th width="250px">账单金额</th>
                <th width="150px">已开票金额</th>
                <th width="150px">正在开票金额</th>
                <th width="150px">未开票金额</th>
              </tr>
              <tr>
                <td>{{ apply_list.length }} 笔</td>
                <td>
                  总共：{{ receivable_amount }} 元<br/>
                  <span style="color: red;">抵扣：{{ deduction_amount }} 元，其中不可开票部分 {{ deduction_no_invoice }} 元 </span>
                </td>
                <td>
                  总共：{{ confirmed_amount + no_invoice_amount}} 元<br/>
                  专票：{{ confirmed_special_amount }} 元<br/>
                  普票：{{ confirmed_ordinary_amount }} 元<br/>
                  收据：{{ no_invoice_amount }} 元 <br/>
                </td>
                <td>
                  总共：{{ application_amount }} 元<br/>
                  专票：{{ application_special_amount }} 元<br/>
                  普票：{{ application_ordinary_amount }} 元
                </td>
                <td>
                  总共：{{ unapplication_amount }} 元<br/>
                  专票：{{ unapplication_special_amount }} 元<br/>
                  普票：{{ unapplication_ordinary_amount }} 元
                </td>
              </tr>
            </table>
          </el-collapse-item>
          <el-collapse-item title="发票明细" name="2">
            <!-- 发票文件列表 -->
            <el-table :key="0" :data="insurance_finance_receivable_list" stripe v-loading="receivable_loading" :element-loading-text="loadingText"
                      fit highlight-current-row class="w-100">
              <!-- id -->
              <el-table-column align="left" label="id" width="70">
              <template slot-scope="scope">
                  <span v-if="showView">
                  {{scope.row.id}}
                  </span>
              </template>
              </el-table-column>

              <!-- 开票类型-->
              <el-table-column align="left" label="开票类型" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.invoice_type === 0?'专票':'普票'}}</span>
              </template>
              </el-table-column>

              <!-- 开票方-->
              <el-table-column align="left" label="开票方" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.invoice_maker}}</span>
              </template>
              </el-table-column>

              <!-- 业务单位明细-->
              <el-table-column align="left" label="业务单位明细" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.name}}</span>
              </template>
              </el-table-column>

              <!-- 开票金额 -->
              <el-table-column align="left" label="开票金额" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.invoiced_amount| parsecurrency}}</span>
              </template>
              </el-table-column>

              <!-- 税价 -->
              <el-table-column align="left" label="税价" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.vat }}</span>
              </template>
              </el-table-column>

              <!-- 销售额 -->
              <el-table-column align="left" label="销售额" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.sales }}</span>
              </template>
              </el-table-column>

              <!-- 发票号码 -->
              <el-table-column align="left" label="发票号码" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.invoice_number }}</span>
              </template>
              </el-table-column>

              <!-- 纳税人识别号 -->
              <el-table-column align="left" label="纳税人识别号" width="220px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.taxpayer_id }}</span>
              </template>
              </el-table-column>

              <!-- 开票时间 -->
              <el-table-column align="left" label="开票时间" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.invoiced_date| parseTime('{y}-{m}-{d}') }}</span>
              </template>
              </el-table-column>

              <el-table-column align="left" label="备注">
              <template slot-scope="scope">
                  <span>{{ scope.row.remark}}</span>
              </template>
              </el-table-column>

              <!-- 操作 -->
              <el-table-column align="left" label="操作" width="150px">
              <template slot-scope="scope">

                <el-tooltip effect="light" placement="top-start" content="查看详情">
                  <el-button type="text"
                      @click="handleView(scope.row.id)" >
                      <i class="el-icon-view"></i>
                  </el-button>
                  </el-tooltip>

                  <el-tooltip effect="light" placement="top-start" content="编辑">
                  <el-button v-if="showEdit" type="text"
                      @click="handleUpdate(scope.row.id, showDialogSave)" >
                      <i class="el-icon-edit"></i>
                  </el-button>
                  </el-tooltip>
<!-- 
                  <el-tooltip effect="light" placement="top-start" content="删除">
                  <el-button v-if="showDelete" type="text"
                      @click="handleDelete(scope.row.id)" >
                      <i class="el-icon-delete"></i>
                  </el-button>
                  </el-tooltip> -->

              </template>
              </el-table-column>
  
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="开票申请" name="3">
            <el-button type="primary" size="small" icon="el-icon-plus" v-if="showAddApplication" @click="handleReceivableApply">申请开票</el-button>
            <!-- 发票文件列表 -->
            <el-table :key="0" :data="insurance_finance_receivable_application_list" stripe v-loading="receivable_application_loading" :element-loading-text="loadingText"
                      fit highlight-current-row class="w-100">
              <!-- id -->
              <el-table-column align="left" label="id" width="70">
              <template slot-scope="scope">
                  <span v-if="showView">
                  {{scope.row.id}}
                  </span>
              </template>
              </el-table-column>

              <!-- 开票类型-->
              <el-table-column align="left" label="开票类型" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.invoice_type === 0?'专票':'普票'}}</span>
              </template>
              </el-table-column>

              <!-- 业务单位明细-->
              <el-table-column align="left" label="业务单位明细" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.name}}</span>
              </template>
              </el-table-column>

              <!-- 申请人-->
              <el-table-column align="left" label="申请人" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.creator_name}}</span>
              </template>
              </el-table-column>

              <!-- 代理人-->
              <!-- <el-table-column align="left" label="代理人" width="120px">
              <template slot-scope="scope">
                  <span  v-if="showView"
                  >{{ scope.row.agent_name}}</span>
              </template>
              </el-table-column> -->

              <!-- 开票金额 -->
              <el-table-column align="left" label="开票金额" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.invoiced_amount| parsecurrency}}</span>
              </template>
              </el-table-column>

              <!-- 开票时间 -->
              <el-table-column align="left" label="申请时间" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.create_time| parseTime }}</span>
              </template>
              </el-table-column>

              <el-table-column align="left" label="状态" width="120px">
              <template slot-scope="scope">
                  <span>{{ scope.row.status_name}}</span>
              </template>
              </el-table-column>

              <el-table-column align="left" label="备注">
              <template slot-scope="scope">
                  <span>{{ scope.row.remark}}</span>
              </template>
              </el-table-column>

              <el-table-column align="left" label="拒绝原因">
              <template slot-scope="scope">
                  <span>{{ scope.row.refuse_reason}}</span>
              </template>
              </el-table-column>

              <!-- 操作 -->
              <el-table-column align="left" label="操作" width="150px">
              <template slot-scope="scope">

                  <el-tooltip effect="light" placement="top-start" content="开票申请编辑">
                  <el-button type="text" v-if="['0'].indexOf(scope.row.status) !== -1 && showEditApplication"
                      @click="handleUpadte(scope.row, showDialogSave)" >
                      <i class="el-icon-edit"></i>
                  </el-button>
                  </el-tooltip>

                  <el-tooltip effect="light" placement="top-start" content="审核">
                  <el-button type="text" v-if="scope.row.status==='0' && showCheckApplication"
                      @click="handleCheck(scope.row.id, showDialogSave)" >
                      <i class="el-icon-document-checked"></i>
                  </el-button>
                  </el-tooltip>

                  <el-tooltip effect="light" placement="top-start" content="删除">
                  <el-button type="text" v-if="['0'].indexOf(scope.row.status) !== -1 && showDeleteApplication"
                      @click="handleDelete(scope.row.id)" >
                      <i class="el-icon-delete"></i>
                  </el-button>
                  </el-tooltip>

              </template>
              </el-table-column>
  
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="业务清单" name="4">
            <el-table border show-summary :data="apply_list">
              <el-table-column prop="customer_name" label="会员名称"></el-table-column>
              <el-table-column prop="ship_name" label="船名"></el-table-column>
              <el-table-column prop="remark.content" label="开票情况"></el-table-column>
              <el-table-column prop="pay_gross_ton" label="船舶总吨"></el-table-column>
              <el-table-column prop="big_premium" label="大桥险保费(元)"></el-table-column>
              <el-table-column prop="risk_premium" label="本期风险准备金(元)"></el-table-column>
              <el-table-column prop="small_premium" label="小桥险保费(元)"></el-table-column>
              <el-table-column prop="dues" label="入会会费(元)"></el-table-column>
              <el-table-column prop="deduction_risk_premium" label="抵扣风险准备金"></el-table-column>
              <el-table-column prop="deduction_insurance_premium" label="抵扣保费"></el-table-column>
              <el-table-column prop="total_amount" label="合计费用(元)"></el-table-column>
              <!-- 操作 -->
              <el-table-column align="left" label="操作" width="150px">
                <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top-start" content="修改开票情况">
                      <el-button type="text" v-if="showEditApply"
                          @click="handleUpdateApply(scope.row)" >
                          <i class="el-icon-edit"></i>
                      </el-button>
                    </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <finance-receivable-dialog ref="receivable"
        :finance_id="insurance_finance_id"
        :receivable_amount="receivable_amount"
        :receivable_special_amount="receivable_special_amount"
        :receivable_ordinary_amount="receivable_ordinary_amount"
        :confirmed_amount="confirmed_amount"
        :confirmed_special_amount="confirmed_special_amount"
        :confirmed_ordinary_amount="confirmed_ordinary_amount"
        :unconfirmed_amount="unconfirmed_amount"
        :unconfirmed_special_amount="unconfirmed_special_amount"
        :unconfirmed_ordinary_amount="unconfirmed_ordinary_amount"
        :application_amount="application_amount"
        :application_special_amount="application_special_amount"
        :application_ordinary_amount="application_ordinary_amount"
        :unapplication_amount="unapplication_amount"
        :unapplication_special_amount="unapplication_special_amount"
        :unapplication_ordinary_amount="unapplication_ordinary_amount"
        :no_invoice="no_invoice_amount"
        @updateList="loadData"
      >
      </finance-receivable-dialog>

      <receivable-application-dialog ref="application"
        :receivable_amount="receivable_amount"
        :receivable_special_amount="receivable_special_amount"
        :receivable_ordinary_amount="receivable_ordinary_amount"
        :confirmed_amount="confirmed_amount"
        :confirmed_special_amount="confirmed_special_amount"
        :confirmed_ordinary_amount="confirmed_ordinary_amount"
        :unconfirmed_amount="unconfirmed_amount"
        :unconfirmed_special_amount="unconfirmed_special_amount"
        :unconfirmed_ordinary_amount="unconfirmed_ordinary_amount"
        :application_amount="application_amount"
        :application_special_amount="application_special_amount"
        :application_ordinary_amount="application_ordinary_amount"
        :unapplication_amount="unapplication_amount"
        :unapplication_special_amount="unapplication_special_amount"
        :unapplication_ordinary_amount="unapplication_ordinary_amount"
        :no_invoice="no_invoice_amount"
        @updateList="loadData"
      >
      </receivable-application-dialog>

      <receivable-no-invoice-dialog ref="noInvoice"
        :finance_id="insurance_finance_id"
        :receivable_amount="receivable_amount"
        :unconfirmed_amount="unconfirmed_amount"
        :no_invoice="no_invoice_amount"
        @updateNoInvoice="setNoInvoice"
      >

      </receivable-no-invoice-dialog>
      
      <el-dialog :visible.sync="InvoiceTitleVisible" width="50%">
        <el-form ref="invoice_title_form" :model="invoice_title_form" :rules="invoice_rules" label-width="150px">
          <el-form-item label="抬头名" width="50%" prop="invoice_name">
            <el-input v-model="invoice_title_form.invoice_name" maxlength="40" disabled></el-input>
          </el-form-item>


          <el-form-item prop="invoice_type" label="抬头类型">
            <el-radio v-model="invoice_title_form.invoice_type" :label=0 >企业</el-radio>
            <el-radio v-model="invoice_title_form.invoice_type" :label=1 >个人</el-radio>
          </el-form-item>


          <el-form-item prop="invoice_default_type" label="默认发票类型">
            <el-radio v-model="invoice_title_form.invoice_default_type" :label='0' >专票</el-radio>
            <el-radio v-model="invoice_title_form.invoice_default_type" :label='1' >普票</el-radio>
          </el-form-item>

     
          <el-form-item label="统一社会信用代码" width="50%" prop="invoice_number">
            <el-input v-model="invoice_title_form.invoice_number"></el-input>
          </el-form-item>
     
      
          <el-form-item label="开户银行名" width="50%">
            <el-input v-model="invoice_title_form.invoice_blank_name"></el-input>
          </el-form-item>

          <el-form-item label="开户账号" width="50%">
            <el-input v-model="invoice_title_form.invoice_account"></el-input>
          </el-form-item>
  
          <el-form-item label="注册场所地址" width="50%">
            <el-input v-model="invoice_title_form.invoice_address"></el-input>
          </el-form-item>

          <el-form-item label="注册固定电话" width="50%">
            <el-input v-model="invoice_title_form.invoice_mobile"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CreateInvoice">确认创建</el-button>
        </span>
    </el-dialog>
      <update-apply-invoice-dialog ref="applyInvoice" @updateList="loadData"></update-apply-invoice-dialog>
    </div>
  </template>
  
  <script>
  import { fetchInsuranceFinanceApplys, fetchInsuranceFinanceReceivables, deleteInsuranceFinanceReceivable, deleteInsuranceFinanceApplicationReceivable,confirmReceivable, fetchInsuranceFinanceReceivableApplications,getInsuranceFinanceApplicationReceivable} from '@/api/group-insurance'
  import FinanceReceivableDialog from './finance-receivable-dialog'
  import ReceivableNoInvoiceDialog from './receivable-no-invoice-dialog'
  import ReceivableApplicationDialog  from './receivable-application-dialog'
  import UpdateApplyInvoiceDialog from './update-apply-invoice-dialog'
  import { formatCurrency } from '@/utils/misc'
  import {InvoiceTitleList,createInvoiceTitle} from '@/api/customer'
  import Pagination from '@/components/Pagination'
  import { EventBus } from "@/utils/event-bus"
  export default {
    components: {
      // Pagination,
      FinanceReceivableDialog,
      ReceivableNoInvoiceDialog,
      ReceivableApplicationDialog,
      UpdateApplyInvoiceDialog,
    },
    data() {
      return {
        invoice_rules: {
          invoice_name: [{required: true, message: '必填'}],
          invoice_number: [{required: true, message: '必填'}]
        },
        loading: false,
        receivable_loading: false,
        receivable_application_loading: false,
        loadingText: '正在加载数据，请稍等...',
        insurance_finance_id: '',
        activeNames: ["1", "2", "3", "4"],
        apply_list: [],
        invoice_title_list:[],
        insurance_finance_receivable_list: [],
        insurance_finance_receivable_application_list: [],
        showView: false,
        showAdd: false,
        showEdit: false,
        showDelete: false,
        showConfirm: false,
        isView:true,
        invoice_title_form:{},
        showDialogSave: true,
        InvoiceTitleVisible:false,
        query:{
          search: '',
        },
        application_query:{
          search: '',
        },
        total: 0,
        application_total: 0,
        no_invoice_amount: 0,
        receivable_ordinary_amount: 0,
        receivable_special_amount: 0,
        showAddApplication: false,
        showEditApplication: false,
        showCheckApplication: false,
        showDeleteApplication: false,
        showEditApply: false,
      }
    },
    computed: {
      // 账单总额
      receivable_amount() {
        let amount = 0
        if (this.apply_list.length > 0) {
          this.apply_list.forEach(a => {
            amount += parseFloat(a.total_amount)
          })
        }
        return parseFloat(amount.toFixed(4))
      },

      // 已开票总额
      confirmed_amount: function() {
        let result = 0.0
        result = this.confirmed_ordinary_amount + this.confirmed_special_amount
        return parseFloat(result.toFixed(4))
      },
      // 已开普票金额
      confirmed_ordinary_amount: function() {
        let result = 0.0
        for (let l of this.insurance_finance_receivable_list) {
          if (l.invoice_type === 1) {
            result = result + parseFloat(l.invoiced_amount)
          }
        }
        return parseFloat(result.toFixed(4))
      },
      // 已开专票金额
      confirmed_special_amount: function() {
        let result = 0.0
        for (let l of this.insurance_finance_receivable_list) {
          if (l.invoice_type === 0) {
            result = result + parseFloat(l.invoiced_amount)
          }
        }
        return parseFloat(result.toFixed(4))
      },

      // 抵扣总额
      deduction_amount: function() {
        let result = 0.0
        for (let l of this.apply_list) { 
            result = result + parseFloat(l.deduction_risk_premium) + parseFloat(l.deduction_insurance_premium)
        }
        return parseFloat(result.toFixed(4))
      },
      // 抵扣不可开票金额
      deduction_no_invoice: function() {
        let result = 0.0
        for (let l of this.apply_list) { 
          result = result + parseFloat(l.deduction_no_invoice)
        }

        if (result>0 && result<=this.receivable_special_amount) {
          this.receivable_special_amount -= result
        } else if (result>0 && result>this.receivable_special_amount) {
          this.receivable_special_amount = 0
          this.receivable_ordinary_amount -= (result-this.receivable_special_amount) 
        }
        return parseFloat(result.toFixed(4))
      },
      
      // 已申请开票总额
      application_amount: function() {
        let result = 0.0
        result = this.application_ordinary_amount + this.application_special_amount
        return parseFloat(result.toFixed(4))
      },
      // 已申请开普票金额
      application_ordinary_amount: function() {
        let result = 0.0
        for (let l of this.insurance_finance_receivable_application_list) {
          if (l.status === '0' && l.invoice_type === 1) {
            result = result + parseFloat(l.invoiced_amount)
          }
        }
        return parseFloat(result.toFixed(4))
      },
      // 已申请开专票金额
      application_special_amount: function() {
        let result = 0.0
        for (let l of this.insurance_finance_receivable_application_list) {
          if (l.status === '0' && l.invoice_type === 0) {
            result = result + parseFloat(l.invoiced_amount)
          }
        }
        return parseFloat(result.toFixed(4))
      },

      // 可用开票总额度
      unapplication_amount() {
        let result = 0.0
        result = this.unapplication_ordinary_amount + this.unapplication_special_amount
        return parseFloat(result.toFixed(4))
      },
      // 可开普票额度
      unapplication_ordinary_amount() {
        let result = 0.0
        result = this.unconfirmed_ordinary_amount - this.application_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      // 可开专票总额
      unapplication_special_amount() {
        let result = 0.0
        result = this.unconfirmed_special_amount - this.application_special_amount
        return parseFloat(result.toFixed(4))
      },

      no_invoice_amount() {
        let amount = 0
        if (this.apply_list.length > 0) {
          this.apply_list.forEach(a => {
            if (parseFloat(a.deduction_no_invoice) > 0) {
              amount += parseFloat(a.deduction_no_invoice)
            }
            else {
              if (a.remark.content.indexOf('1') !== -1) {
                amount += parseFloat(a.risk_premium)   
                amount += parseFloat(a.big_premium)
                amount += parseFloat(a.small_premium)
                amount += parseFloat(a.dues)        
              } else if (a.remark.content.indexOf('2') !== -1) {
                amount += parseFloat(a.risk_premium)
              } else if (a.remark.content.indexOf('5') !== -1) {
                amount += parseFloat(a.risk_premium)
              }
            }
          })
        }
        return parseFloat(amount.toFixed(4))
      },
      unconfirmed_amount() {
        let result = 0.0
        result = this.unconfirmed_ordinary_amount + this.unconfirmed_special_amount
        return parseFloat(result.toFixed(4))
      },
      unconfirmed_ordinary_amount() {
        let result = 0.0
        result = this.receivable_ordinary_amount - this.confirmed_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      unconfirmed_special_amount() {
        let result = 0.0
        result = this.receivable_special_amount - this.confirmed_special_amount
        return parseFloat(result.toFixed(4))
      },
      
      // 确认开票完成条件
      is_completed: function() {
        let result = false
        if (
          parseFloat(this.unapplication_amount) === 0.0
          // this.receivable_ordinary_amount === this.confirmed_ordinary_amount && parseFloat(this.unconfirmed_ordinary_amount) === 0.0 &&
          // this.receivable_special_amount === this.confirmed_special_amount && parseFloat(this.unconfirmed_special_amount) === 0.0 &&
          // parseFloat(this.unapplication_ordinary_amount) === 0.0 && parseFloat(this.application_ordinary_amount) === 0.0 &&
          // parseFloat(this.unapplication_special_amount) === 0.0 && parseFloat(this.application_special_amount) === 0.0
        ){
          result = true
        }
        return result
      }
    },
    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },
    },
    methods: {
      CreateInvoiceTitleDetail(){
        this.InvoiceTitleVisible = true
        this.invoice_title_form.invoice_name = this.apply_list[0].customer_name
      },
      CreateInvoice(){
        this.$refs.invoice_title_form.validate(valid => {
          if (valid) {
            if (this.invoice_title_form.invoice_name === ''){
              this.$error_message('请填写抬头名！')
              return
            }
            this.invoice_title_form.member = this.apply_list[0].customer
            createInvoiceTitle(this.invoice_title_form).then(() => {
              this.InvoiceTitleVisible = false
              this.getInvoiceList(this.apply_list[0].customer)
              this.invoice_title_form = {}
              this.$message.success('创建发票信息成功！')
            })
          }
        })
      },
      invoice_computer(apply_list) {
        this.receivable_special_amount = 0
        this.receivable_ordinary_amount = 0
        apply_list.forEach(a => {
          // 计算预估专票总额
          if (a.remark.content.indexOf('2') !== -1 || a.remark.content.indexOf('3') !== -1) {
            this.receivable_special_amount += parseFloat(a.big_premium)
            this.receivable_special_amount += parseFloat(a.small_premium)
            this.receivable_special_amount += parseFloat(a.dues)
          }
          // 计算预估普票总额
          if (a.remark.content.indexOf('3') !== -1) {
            this.receivable_ordinary_amount += parseFloat(a.risk_premium)         
          } else if (a.remark.content.indexOf('4') !== -1) {
            this.receivable_ordinary_amount += parseFloat(a.total_amount)
          } else if (a.remark.content.indexOf('5') !== -1) {
            this.receivable_ordinary_amount += parseFloat(a.big_premium)
            this.receivable_ordinary_amount += parseFloat(a.small_premium)
            this.receivable_ordinary_amount += parseFloat(a.dues)
          }
        })
      },
      loadData() {
        this.loading = true
        let p =[]
        p.push(fetchInsuranceFinanceApplys(this.insurance_finance_id))
        p.push(fetchInsuranceFinanceReceivables(this.insurance_finance_id, this.query))
        p.push(fetchInsuranceFinanceReceivableApplications(this.insurance_finance_id, this.application_query))
        Promise.all(p).then(res => {
          this.loading = false
          this.apply_list = res[0].apply_list
          this.insurance_finance_receivable_list = res[1]
          this.total = res[1].length
          this.insurance_finance_receivable_application_list = res[2]
          this.application_total = res[2].length
          // this.no_invoice = res[0].no_invoice
          this.getInvoiceList(this.apply_list[0].customer)
          this.invoice_computer(this.apply_list)
          if (res[0].is_invoice){
            this.showAdd = false
            this.showAddApplication = false
            this.showCheckApplication = false
            this.showDeleteApplication = false
            this.showConfirm = false
            // this.showEdit = false
            this.showDelete = false
            this.showDialogSave = false
            this.showEditApply = false
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      },
      handleReceivableCreate() {
        let name = ''
        if (this.apply_list.length > 0) {
          name = this.apply_list[0].customer_name
        }
        this.getInvoiceList(this.apply_list[0].customer)
        let invoice_maker = '互助中心'
        let invoice_title_list = this.invoice_title_list
        this.$refs.receivable.handleCreate(invoice_maker, name,invoice_title_list)
      },
      handleReceivableApply() {
        let customer = ''
        if (this.apply_list.length > 0) {
          customer = this.apply_list[0].customer
        }
        this.getInvoiceList(this.apply_list[0].customer)
        let invoice_title_list = this.invoice_title_list
        this.$refs.receivable.handleApply(invoice_title_list,customer,this.insurance_finance_receivable_application_list)
      },
      getInvoiceList(value){
        InvoiceTitleList({'member':value})
            .then(res => {
                this.invoice_title_list = res.filter(data => data.invoice_name === this.apply_list[0].customer_name)
            })
            .catch(error => {
              this.$error_message(error)
            })
      },
      handleUpdate(id, showDialogSave) {
        this.$refs.receivable.handleUpdate(id, showDialogSave)
      },
      handleView(id) {
        this.isView = true
        this.$refs.receivable.handleView(id, false)
      },
      handleDelete(id){
        this.$confirm('是否确认删除该开票申请?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.loading = true
          deleteInsuranceFinanceApplicationReceivable({id:id})
            .then(() => {
              this.loading = false
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              setTimeout(() => {
                this.loadData()
              }, 1000)
              })
            })
            .catch(error => {
              this.loading = false
              this.$message.error(error)
            })
        }).catch((e) => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
      },
      handleConfirm() {
        this.$confirm('确认后将完成开票确认,完成后该对账文件将不允许修改以及删除, 是否继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.loading = true
          confirmReceivable(this.insurance_finance_id)
            .then(() => {
              this.loading = false
              this.$message.success('更新账单信息成功')
              this.$nextTick(() => {
                this.loadData()
              })
            })
            .catch(error => {
              this.loading = false
              this.$message.error(error)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消开票确认'
          });
        });
      },
      handleNoInvoice(showDialogSave) {
        this.$refs.noInvoice.handleUpdate(showDialogSave)
      },
      setNoInvoice(no_invoice_amount) {
        this.no_invoice_amount = no_invoice_amount
      },
      handleCheck(id, showDialogSave) {
        this.$refs.application.handleCheck(id, showDialogSave)
      },
      handleUpadte(row, showDialogSave) {
        this.isShow = false
        this.getInvoiceList(this.apply_list[0].customer)
        let invoice_title_list = this.invoice_title_list
        this.$refs.application.handleUpadte(row.id, showDialogSave,this.insurance_finance_receivable_application_list,row.invoiced_amount,invoice_title_list)
      },
      handleUpdateApply(row) {
        this.$refs.applyInvoice.handleUpdate(row)
      }
    },
    beforeRouteLeave (to, from, next) {
      if (['ReceivableApplicationList', 'CollectList'].indexOf(to.name) == -1 ) {
        window.localStorage.removeItem('query')
      }
      next()
    },
    created() {
      // 入参处理
      if (this.$route.query.id === undefined){
        this.$router.push('/404')
      }
      this.insurance_finance_id = this.$route.query.id
      // 权限检查
      if (!this.$perm(["group_insurance.list_finance_receivable"])) {
        this.$router.push('/401')
      }
      this.showView = true
  
      if (this.$perm(["group_insurance.create_finance_receivable"])) {
        this.showAdd = true
      }
  
      if (this.$perm(["group_insurance.confirm_finance_receivable"])) {
        this.showConfirm = true
      }
  
      if (this.$perm(["group_insurance.update_finance_receivable"])) {
        this.showEdit = true
      }
      if (this.$perm(["group_insurance.create_finance_receivable_application"])) {
        this.showAddApplication = true
      }
      if (this.$perm(["group_insurance.update_finance_receivable_application"])) {
        this.showEditApplication = true
      }
      if (this.$perm(["group_insurance.check_finance_receivable_application"])) {
        this.showCheckApplication = true
      }
      if (this.$perm(["group_insurance.delete_finance_receivable_application"])) {
        this.showDeleteApplication = true
      }
  
      if (this.$perm(["group_insurance.delete_finance_receivable"])) {
        this.showDelete = true
      }
      this.showEditApply = true
      this.loadData()    
    }
  }
  </script>